<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <div class="bodyCenter">
      <div class="modalStyle">
        <div class="titulos">
          <div class="seccionTitle">
            <b-icon icon="file-earmark-text-fill" class="mLeft"></b-icon>
            <div class="headerTxt mLeft">Administración de sesiones</div>
          </div>
          <div class="alignIcon bold">AS_01_admin_sesiones</div>
        </div>
        <b-tabs class="noAlTope">
          <b-tab title="Tratamientos">
            <tratamientos />
          </b-tab>
          <b-tab
            title="Cambio de Plan - PTI"
            v-if="$localStorageService.can('PL_01_id_plan_pti')"
            lazy
          >
            <ptiPlan />
          </b-tab>

          <b-tab title="Asignación de Plan - PTI" lazy>
            <ptiPlanPaciente />
          </b-tab>

          <b-tab
            title="Migración de datos del v3"
            v-if="$localStorageService.can('MD_01_migrar')"
          >
            <AdministracionMigraciones />
          </b-tab>
          <b-tab
            title="Comisiones"
            v-if="$localStorageService.can('C0_01_AC_comisiones')"
          >
            <CrearComisiones />
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header";
import tratamientos from "../../components/administracionSesiones/AdministracionTratamientos.vue";
import ptiPlan from "../../components/administracionSesiones/AdministracionPtiPlan.vue";
import AdministracionMigraciones from "../../components/administracionSesiones/AdministracionMigraciones.vue";
import ptiPlanPaciente from "../../components/administracionSesiones/PtiPlanPaciente.vue";
import CrearComisiones from "../Compensaciones/CrearComisiones";

export default {
  name: "AdministracionSesion",
  components: {
    CrearComisiones,
    Header,
    tratamientos,
    ptiPlan,
    ptiPlanPaciente,
    AdministracionMigraciones,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>

<style scoped>
</style>
